export const currentlyFocusedElement = () => {
  try {
    let focused = document.activeElement;
    if (!focused || focused == document.body) {
      focused = null;
    } else if (document.querySelector) {
      focused = document.querySelector(":focus");
    }
    return focused;
  } catch (error: unknown) {
    return null;
  }
};
